import React from 'react';
import { SearchAdMode } from './SearchAdTypes';

type SearchAdContext = {
    headingId: string;
    linkId?: string;
    mode: SearchAdMode;
    onClick?: (ev: React.MouseEvent) => void;
    target?: string;
    url?: string;
};

const SearchAdContext = React.createContext<SearchAdContext | undefined>(
    void 0,
);

type SearchAdContextProviderProps = Omit<SearchAdContext, 'mode'> & {
    children: React.ReactNode;
    mode?: SearchAdMode;
};

export function SearchAdContextProvider(props: SearchAdContextProviderProps) {
    const {
        children,
        headingId,
        linkId,
        mode = 'responsive',
        onClick,
        target,
        url,
    } = props;

    const value = React.useMemo<SearchAdContext>(
        () => ({
            headingId,
            linkId,
            mode,
            onClick,
            target,
            url,
        }),
        [headingId, linkId, mode, onClick, target, url],
    );

    return (
        <SearchAdContext.Provider value={value}>
            {children}
        </SearchAdContext.Provider>
    );
}

export function useSearchAdContext() {
    const context = React.useContext(SearchAdContext);
    if (typeof context === 'undefined') {
        throw new Error(
            'useSearchAdContext must be used within a SearchAdContextProvider',
        );
    }
    return context;
}
